import React, { useEffect, useRef, useState } from "react";
import { Button, Select, DatePicker, Form, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
	fetchSurveys,
	downloadSurvey,
	resetDownloadCsv,
} from "../../actions/survey";
import { fetchCategories } from "../../actions/category";

import "./Surveys.scss";
import { Link } from "react-router-dom";
import { PAGE_SIZE } from "../../constants";
import SurveysTable from "../Tables/Surveys";
import moment from "moment";
import { CSVLink } from "react-csv";
import { ReactSVG } from "react-svg";

const { RangePicker } = DatePicker;

const SurveysPage = () => {
	const dispatch = useDispatch();
	const { surveys, loading } = useSelector((state) => state.fetchSurveys);
	const { categories } = useSelector((state) => state.fetchCategories);
	const { file } = useSelector((state) => state.downloadSurveys);
	const [pagination, setPagination] = useState({});
	const [currentPage, setCurrentPage] = useState(1);
	const limit = Number(PAGE_SIZE) || 20;
	const csvLink = useRef();
	const [selectValue, setSelectValue] = useState([]);

	function disabledDate(current) {
		return current && current > moment().endOf("day");
	}

	const selectProps = {
		mode: "multiple",
		showSearch: true,
		style: {
			width: "100%",
		},
		selectValue,
		onChange: (newValue) => {
			setSelectValue(newValue);
		},
		maxTagCount: "responsive",
		placeholder: "Survey Categories",
		optionFilterProp: "children",
		filterOption: (input, option) =>
			option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0,

		rules: [{ required: true, message: "Required" }],
	};

	const withAction = (record) => {
		return (
			<span className="action" style={{ display: "flex" }}>
				<Link to={`/surveys/${record.id}`}>
					<Button type="link" className="btn-table-action-primary">
						View
					</Button>
				</Link>
			</span>
		);
	};

	const onSubmit = (values) => {
		const newValues = { ...values };
		newValues.start_date = moment(newValues.date_range[0]).format("DD/MM/YYYY");
		newValues.end_date = moment(newValues.date_range[1]).format("DD/MM/YYYY");
		delete newValues.date_range;
		dispatch(downloadSurvey(newValues));
	};

	const handleFilter = (params) => {
		setCurrentPage(params.page);
		const startAt = (params.page - 1) * Number(PAGE_SIZE);
		dispatch(fetchSurveys({ start: Number(startAt), count: PAGE_SIZE }));
	};

	const handleTableChange = (params) => {
		handleFilter(params);
	};

	useEffect(() => {
		dispatch(fetchSurveys({ start: 0, count: PAGE_SIZE }));
		dispatch(fetchCategories());
	}, []);

	useEffect(() => {
		if (surveys) {
			setPagination({
				showSizeChanger: false,
				current: currentPage,
				pageSize: limit,
				total: surveys.data.total,
				showTotal: (total) => `${total} Items`,
			});
		}
	}, [surveys]);

	const [csvFile, setCsvFile] = useState("");
	const [isDownloaded, setIsDownloaded] = useState(false);

	useEffect(() => {
		if (file) {
			if (!isDownloaded) {
				setCsvFile(file);
				setIsDownloaded(true);
				dispatch(resetDownloadCsv());
				setTimeout(() => {
					csvLink.current.link.click();
				});
			}
		}
	}, [file]);

	return (
		<Spin spinning={loading} tip="Loading ...">
			<div className="surveys-container">
				<div className="page-header">
					<div className="page-header-breadbrumb">
						<ul>
							<li>Surveys</li>
						</ul>
					</div>
				</div>
				<div className="download-section">
					<CSVLink
						data={csvFile}
						filename={`eys-surveys.csv`}
						className="hidden"
						ref={csvLink}
						target="_blank"
					/>
					<Form onFinish={onSubmit}>
						<Form.Item
							name="survey_category_ids"
							className="survey-ceategories-filter"
						>
							<Select {...selectProps}>
								{categories &&
									categories.data.data.map((category) => (
										<Select.Option key={category.id} value={category.id}>
											{category.name}
										</Select.Option>
									))}
							</Select>
						</Form.Item>
						<Form.Item
							name="date_range"
							rules={[{ required: true, message: "Required" }]}
						>
							<RangePicker disabledDate={disabledDate} />
						</Form.Item>
						<div className="form-actions">
							<Button
								type="text"
								className="btn btn-secondary"
								htmlType="submit"
							>
								Download
								<ReactSVG src="/icons/file-download.svg" />
							</Button>
						</div>
					</Form>
				</div>
				<div className="page-content">
					{surveys && (
						<SurveysTable
							rowKey="id"
							dataSource={surveys.data.data}
							pagination={pagination}
							onChange2={handleTableChange}
							scrollHeight="calc(100vh - 275px)"
							actionWidth={150}
							withAction={withAction}
						/>
					)}
				</div>
			</div>
		</Spin>
	);
};

export default SurveysPage;
